
export class fileUpload
    {
        File: any;
        IsExcelFile: boolean;

    }